export default __webpack_public_path__ + "static/media/bank-documents.5acbb35c.svg";